import PhoneInput, { Props, DefaultInputComponentProps } from "react-phone-number-input"
import { FC } from "react"
import clsx from "clsx"

export interface ManualPhoneNumberProps extends Props<DefaultInputComponentProps> {
  error?: any
  inputClassname?: string
}

export const ManualPhoneNumber: FC<ManualPhoneNumberProps> = ({
  error,
  className,
  inputClassname,
  ...props
}) => {
  return (
    <div className={clsx("phone_input", className)}>
      <PhoneInput
        defaultCountry="ID"
        {...props}
        className={clsx(
          inputClassname,
          "rounded px-3 py-2.5 border-2 border-grey-ec",
          error && "border-2 !border-red",
          props.value && "border-2 !border-green"
        )}
      />
      <small className="text-red">{error}</small>
    </div>
  )
}
